<template>
    <fade-up-animation :element="() => $refs.section">
        <section class="all-locations-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <b-col xl="10" offset-xl="1">
                        <h2 class="title" v-test:title>
                            {{ title }}
                        </h2>

                        <ul class="areas list-unstyled">
                            <li
                                v-for="area in areas"
                                :key="area.name"
                                class="item"
                            >
                                <b-button
                                    variant="light"
                                    :to="area.to"
                                    class="area-btn"
                                    block
                                    v-test:areaButton
                                >
                                    {{ area.name }}
                                </b-button>
                            </li>
                        </ul>
                    </b-col>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    export default {
        name: 'all-locations-section',

        props: {
            title: {
                type: String,
                required: true,
            },

            areas: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .all-locations-section {
        padding-top: 20px;
        padding-bottom: 50px;
    }

    .title {
        text-align: center;
        font-size: rem(40px);
        line-height: rem(48px);
        font-weight: 700;
        margin-bottom: 50px;
    }

    .areas {
        display: grid;
        grid-template-columns: repeat(2, auto);
        grid-gap: 20px 26px;
        @include media-breakpoint-up(md) {
            grid-template-columns: repeat(3, auto);
        }
        @include media-breakpoint-up(lg) {
            grid-template-columns: repeat(4, auto);
        }
        @include media-breakpoint-up(xl) {
            grid-template-columns: repeat(5, auto);
        }
    }

    .area-btn {
        background-color: secondary-palette(7);

        &:hover,
        &:focus-visible,
        &:active {
            background-color: primary-palette(1);
            border-color: transparent;
            color: $white;
        }
    }
</style>
